export default __webpack_public_path__ + "static/media/celebrate.9c303ca1.png";